import { canManageRiskAndOppProcess } from "../../constants/riskAndOpportunityRoles";

export const isActiveProcessByRole = (roleList, processId) => {
  return canManageRiskAndOppProcess(roleList, processId);
};
